<template>
  <section>
    <div class="left">
      <translation-language-selector
          :allowed-languages="allowedLanguages"
          :selected-languages="selectedLanguages"
          :is-editable="isEditable"
          @input="onSelectedLanguageChange"
          @onLanguageListSelectionChange="onLanguageListSelectionChange"
          ref="languageSelector"
        />
    </div>

    <div class="right">
        <text-input id="advertisingbannersubject"
                    name="advertisingbannersubject"
                    ref="advertisingbannersubjectref"
                    v-model="entity.subject[selectedLanguage]"
                    :disabled="!isEditable || selectedLanguage == null"
                    maxLength="50"
        >
          <translate class="translate">Nadpis oznámení</translate> *
        </text-input>

      <text-input id="advertisingbannerlabel"
                  name="advertisingbannerlabel"
                  ref="advertisingbannerlabelref"
                  v-model="entity.label[selectedLanguage]"
                  :disabled="!isEditable || selectedLanguage == null"
                  maxLength="30"
      >
        <translate class="translate">Štítek</translate> *
      </text-input>

      <p class="field">
        <html-editor
            :key="'html_editor_'+selectedLanguage"
            id="advertisingbannerbody"
            name="advertisingbannerbody"
            :custom-toolbar="customToolbar"
            :body="entity.body[selectedLanguage]"
            @newVal="entity.body[selectedLanguage] = arguments[0]"
            ref="advertisingbannerbodyref"
            :disabled="!isEditable || selectedLanguage == null">
          <translate class="translate">Tělo oznámení</translate> *
        </html-editor>
      </p>
    </div>
  </section>
</template>

<script>
import advertisingBanners from "./../mixins/advertisingBanners";
import HtmlEditor from "../../../common/HtmlEditor.vue";
import TranslationLanguageSelector from "../../../common/TranslationLanguageSelector.vue";

export default {
  name: "AdvertisingBannerMessageForm",
  components: {HtmlEditor, TranslationLanguageSelector},
  mixins: [advertisingBanners],
  props: {
    entity: Object,
    isUpdate: Boolean,
    isEditable: Boolean,
  },
  data(){
    return {
      selectedLanguage: null,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{
          color: []
        }]
      ]
    }
  },
  computed: {
    allowedLanguages() {
      let languagesToSelect = []
      for (let key in this.$language.available) {
        languagesToSelect.push({value: key.toLowerCase(), text: key})
      }

      return languagesToSelect
    },
    selectedLanguages(){
      let result = {};
      if(this.entity.id){
        var keys = Object.keys(this.entity.body);
        keys.forEach(key => {
          result[key] = true;
        })
        this.onLanguageListSelectionChange(keys)
        this.$refs.languageSelector.preselectLanguages(keys);
      }else{
        let language = this.$store.getters.getLanguage;
        let index = 0;
        if(language){
          language = language.toLowerCase();
          for(let key in this.allowedLanguages){
            if(this.allowedLanguages[key].value == language){
              index = key;
            }
          }
        }
        if(this.allowedLanguages.length > 0){
          result[this.allowedLanguages[index].value] = true;
        }
      }

      return result;
    }
  },
  methods: {
    onSelectedLanguageChange(selectedLanguage, selectedLanguages){
      this._normalizeData(this.entity.subject, selectedLanguages);
      this._normalizeData(this.entity.body, selectedLanguages);
      this._normalizeData(this.entity.label, selectedLanguages);
      this.selectedLanguage = selectedLanguage;
      this.$emit('selectedLanguageChange', selectedLanguage)
    },
    onLanguageListSelectionChange(selectedLanguages){
      this._normalizeData(this.entity.subject, selectedLanguages);
      this._normalizeData(this.entity.body, selectedLanguages);
      this._normalizeData(this.entity.label, selectedLanguages);
    },
    _normalizeData(data, selectedLanguages){
      let dataLanguages = Object.keys(data);
      let addedKeys = selectedLanguages.filter(x => !dataLanguages.includes(x));
      let deletedKeys = dataLanguages.filter(x => !selectedLanguages.includes(x));
      for(const key of addedKeys){
        data[key] = "";
      }
      for(const key of deletedKeys){
        delete data[key];
      }

      return data;
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingBanner/Forms/Message.vue